import NewEntry from "./NewEntry";

export default NewEntry;
